import { render, staticRenderFns } from "./AddContactUser.vue?vue&type=template&id=115989be&scoped=true"
import script from "./AddContactUser.vue?vue&type=script&lang=js"
export * from "./AddContactUser.vue?vue&type=script&lang=js"
import style0 from "./AddContactUser.vue?vue&type=style&index=0&id=115989be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115989be",
  null
  
)

export default component.exports